import { render, staticRenderFns } from "./previewBasic.vue?vue&type=template&id=1f676806&"
import script from "./previewBasic.vue?vue&type=script&lang=js&"
export * from "./previewBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports